import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { ResultCodeEnum } from "../data/ResultCodeEnum";
import { useTranslation } from "react-i18next";
import useRequest from "./useRequest";

const sendToLogin = [
  ResultCodeEnum.Token_Empty,
  ResultCodeEnum.Token_Type,
  ResultCodeEnum.Token_Unauthorized,
  ResultCodeEnum.Token_Expired,
  ResultCodeEnum.Unauthorized_Os,
  ResultCodeEnum.Unauthorized_Ip,
  ResultCodeEnum.Unauthorized_Browser,
  ResultCodeEnum.Unauthorized_Location,
];
const acceptResponse = [
  ResultCodeEnum.Ok,
  ResultCodeEnum.Invalid_Input,
  ResultCodeEnum.Username_NotExist,
  ResultCodeEnum.Username_Password,
  ResultCodeEnum.Record_Status,
];

const useAxios = () => {
  const { i18n, t } = useTranslation();
  const [data, setData] = useState(undefined);
  const pathname = window.location.pathname;
  const url = window.location.origin + pathname;
  const controllerRef = useRef(null);
  const request = useRequest();

  const [loading, setLoading] = useState(false);
  const toastError = (error) => {
    toast.warning(error, {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  };
  const fetchData = useCallback(
    async (cfg) => {
      /* 1. cancel any running request */
      controllerRef.current?.abort();
      controllerRef.current = new AbortController();
      const signal = controllerRef.current.signal;
      try {
        setLoading(true);
        const res = await axios.request({
          signal,
          headers: request,
          ...cfg,
        });
        const body = res.data;
        const code = body.Result;
        if (acceptResponse.includes(code)) {
          setData(body);
        } else if (sendToLogin.includes(code)) {
          // toastError(body.Message);
          localStorage.removeItem(process.env.REACT_APP_TOKENNAME);
          const redirectUrl = `${process.env.REACT_APP_AUTHENTICATIONPATH}/${
            i18n.language
          }?callbackUrl=${encodeURIComponent(url)}`;
          window.location.href = redirectUrl;
          // setData(null);
        } else if (code === ResultCodeEnum.Recognition_Quality) {
          setData(body);
        } else {
          toastError(body.Message);
          setData(null);
        }
      } catch (err) {
        if (axios.isCancel(err)) return; // request was aborted

        // generic error handling (400 validation or others)
        const resp = err.response;
        if (resp?.status === 400 && resp.data?.errors) {
          const keys = Object.keys(resp.data.errors);
          const firstKey = keys.length > 1 ? keys[1] : keys[0];
          toastError(
            firstKey ? t("requiredField", { val: firstKey }) : t("serverError"),
          );
        } else {
          toastError(t("serverError"));
        }
        setData(null);
      } finally {
        setLoading(false);
      }
    },
    [i18n.language, request, t, url],
  );

  /** clear on unmount */
  useEffect(() => () => controllerRef.current?.abort(), []);
  const reset = () => {
    controllerRef.current?.abort();
    setData(null);
  };
  return { response: data, loading, fetchData, reset, request };
};
export default useAxios;
